import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiSave, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, onValue, set } from 'firebase/database';

const ReadyreckonerRates = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {}; // Context data

  const [selectedType, setSelectedType] = useState('');
  const [types, setTypes] = useState([]);
  const [isAllWards, setIsAllWards] = useState(false);
  const [bulkRates, setBulkRates] = useState({ readyreckoner: 0, construction: 0 });

  // Static Ward List (In future, this could also come from DB)
  const initialWardData = [
    { id: 1, village: 'इनाम धामणी', ward: 'गावठाण', readyreckoner: 0, construction: 0 },
    { id: 2, village: 'इनाम धामणी', ward: 'जिरायत शेत जमिन', readyreckoner: 0, construction: 0 },
    { id: 3, village: 'इनाम धामणी', ward: 'बिनशेती जमिनी/भुखंड', readyreckoner: 0, construction: 0 },
    { id: 4, village: 'इनाम धामणी', ward: 'हायवेवरील जमिनी', readyreckoner: 0, construction: 0 },
    { id: 5, village: 'इनाम धामणी', ward: 'औद्योगिक बिनशेती जमिनी', readyreckoner: 0, construction: 0 },
    { id: 6, village: 'इनाम धामणी', ward: 'ss1', readyreckoner: 0, construction: 0 },
  ];

  const [wardData, setWardData] = useState(initialWardData);

  // Fetch Readyreckoner Types
  useEffect(() => {
    const typesRef = ref(database, 'Grampanchayat/Gramniddhi/readyreckonertype');
    const unsubscribe = onValue(typesRef, (snapshot) => {
      const fetchedTypes = [];
      snapshot.forEach((child) => {
        fetchedTypes.push({
          id: child.key,
          ...child.val()
        });
      });
      setTypes(fetchedTypes);
      if (fetchedTypes.length > 0 && !selectedType) {
        setSelectedType(fetchedTypes[0].id);
      }
    });

    return () => unsubscribe();
  }, [selectedType]); // Added selectedType to dependencies to ensure initial selection logic runs correctly if needed

  // Fetch Rates when Selected Type changes
  useEffect(() => {
    if (!selectedType) return;

    const ratesRef = ref(database, `Grampanchayat/Gramniddhi/readyreckonerrate/${selectedType}`);
    const unsubscribe = onValue(ratesRef, (snapshot) => {
      const dbRates = snapshot.val() || {};
      
      // Merge DB rates with Ward Data
      const updatedWards = initialWardData.map(ward => {
        // Check if rate exists for this ward ID
        if (dbRates[ward.id]) {
            return {
                ...ward,
                readyreckoner: dbRates[ward.id].readyreckoner || 0,
                construction: dbRates[ward.id].construction || 0
            };
        }
        return ward; // Keep initial/default values if no saved rate
      });
      
      setWardData(updatedWards);
    });

    return () => unsubscribe();
  }, [selectedType]);


  // Handle individual row change
  const handleRateChange = (id, field, value) => {
    setWardData(prev => prev.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    ));
  };

  // Handle bulk rate input change
  const handleBulkInputChange = (e) => {
    const { name, value } = e.target;
    setBulkRates(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Apply bulk rates
  const applyBulkRates = () => {
    if (isAllWards) {
      setWardData(prev => prev.map(item => ({
        ...item,
        readyreckoner: bulkRates.readyreckoner,
        construction: bulkRates.construction
      })));
    }
  };

  const handleSave = () => {
      if (!selectedType) {
          alert('कृपया रेडीरेकनर प्रकार निवडा');
          return;
      }

      const selectedTypeName = types.find(t => t.id === selectedType)?.typeName || '';

      // Prepare data object: { wardId: { readyreckoner, construction, ...details } }
      const ratesToSave = {};
      wardData.forEach(ward => {
          ratesToSave[ward.id] = {
              readyreckoner: ward.readyreckoner,
              construction: ward.construction,
              wardName: ward.ward,
              villageName: ward.village,
              typeId: selectedType,
              typeName: selectedTypeName
          };
      });

      const ratesRef = ref(database, `Grampanchayat/Gramniddhi/readyreckonerrate/${selectedType}`);
      set(ratesRef, ratesToSave)
        .then(() => {
            alert('दर यशस्वीरित्या साठवले!');
        })
        .catch((error) => {
            alert('साठवताना त्रुटी आली: ' + error.message);
        });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#267c77] text-white rounded-t-lg shadow-lg p-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
             <button 
              onClick={() => navigate('/asthapan/tax-system', { state: location.state })}
              className="p-1 rounded-full hover:bg-white/20 transition-colors"
            >
              <FiArrowLeft size={24} />
            </button>
            <h1 className="text-xl font-bold">रेडी रेकनर दर माहिती</h1>
          </div>
        </div>
      
        <div className="bg-white rounded-b-lg shadow-lg p-6 border border-gray-200 space-y-6">
          
          {/* Controls Row */}
          <div className="flex flex-col md:flex-row gap-4 items-center">
            <div className="w-full md:w-1/4">
              <label className="block text-gray-700 font-medium mb-1">रेडीरेकनर प्रकार</label>
            </div>
            <div className="w-full md:w-3/4 flex gap-4">
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="flex-1 p-2 border border-[#267c77]/30 rounded focus:ring-[#267c77] focus:border-[#267c77] outline-none"
              >
                <option value="">निवडा</option>
                {types.map(type => (
                    <option key={type.id} value={type.id}>{type.typeName}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Bulk Update Row */}
          <div className="flex flex-col md:flex-row gap-4 items-end border-t pt-6">
            <div className="flex items-center mb-2 md:mb-0">
               <input
                type="checkbox"
                id="allWards"
                checked={isAllWards}
                onChange={(e) => setIsAllWards(e.target.checked)}
                className="w-5 h-5 text-[#267c77] rounded focus:ring-[#267c77] border-gray-300 mr-2"
              />
              <label htmlFor="allWards" className="font-bold text-gray-700">सर्व वार्डासाठी</label>
            </div>

            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
               <div>
                  <label className="block text-gray-600 text-sm mb-1">रेडिरकनर दर</label>
                  <input
                    type="number"
                    name="readyreckoner"
                    value={bulkRates.readyreckoner}
                    onChange={handleBulkInputChange}
                    className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-[#267c77] outline-none text-right"
                  />
               </div>
               <div>
                  <label className="block text-gray-600 text-sm mb-1">बांधकामाचा दर</label>
                  <input
                    type="number"
                    name="construction"
                    value={bulkRates.construction}
                    onChange={handleBulkInputChange}
                    className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-[#267c77] outline-none text-right"
                  />
               </div>
            </div>

            <button 
              onClick={applyBulkRates}
              disabled={!isAllWards}
              className={`px-6 py-2 rounded font-medium transition-colors text-white ${isAllWards ? 'bg-[#267c77] hover:bg-[#1e6b66]' : 'bg-gray-400 cursor-not-allowed'}`}
            >
              बदलणे
            </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto mt-6">
            <table className="w-full text-sm text-left border border-[#267c77]">
              <thead className="bg-[#267c77] text-white">
                <tr>
                  <th className="px-4 py-3 border-r border-white/30">गावाचे नाव</th>
                  <th className="px-4 py-3 border-r border-white/30">वार्डचे नाव</th>
                  <th className="px-4 py-3 border-r border-white/30 text-right w-48">रेडीरकनर दर</th>
                  <th className="px-4 py-3 text-right w-48">बांधकामाचा दर</th>
                </tr>
              </thead>
              <tbody>
                {wardData.map((item) => (
                  <tr key={item.id} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-2 border-r border-gray-300">{item.village}</td>
                    <td className="px-4 py-2 border-r border-gray-300">{item.ward}</td>
                    <td className="px-4 py-2 border-r border-gray-300">
                      <input
                        type="number"
                        value={item.readyreckoner}
                        onChange={(e) => handleRateChange(item.id, 'readyreckoner', e.target.value)}
                        className="w-full p-1 border border-[#267c77]/30 rounded text-right outline-none focus:border-[#267c77]"
                      />
                    </td>
                    <td className="px-4 py-2">
                      <input
                        type="number"
                        value={item.construction}
                        onChange={(e) => handleRateChange(item.id, 'construction', e.target.value)}
                        className="w-full p-1 border border-[#267c77]/30 rounded text-right outline-none focus:border-[#267c77]"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
           {/* Footer Actions */}
            <div className="flex justify-center mt-6 gap-4">
               <button 
                  onClick={handleSave}
                  className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2 rounded shadow transition-colors font-bold flex items-center gap-2"
                >
                  <FiSave /> साठविणे
                </button>
               <button 
                  onClick={() => navigate('/asthapan/tax-system', { state: location.state })}
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-2 rounded shadow transition-colors font-bold flex items-center gap-2"
                >
                  <FiX /> बंद करणे
                </button>
            </div>

        </div>
      </div>
    </div>
  );
};

export default ReadyreckonerRates;
